export default __webpack_public_path__ + "static/media/firstrunner.94bbaa08.png";